export function splitUnitName(unit_name) {
  let splittedName = unit_name.split(' ')
  if (splittedName.length <= 1) splittedName = unit_name.split('_')
  splittedName.forEach((name, index) => {
    if (name.length <= 4) {
      if (splittedName[index + 1] && splittedName[index + 1].length <= 8) {
        splittedName[index] = name + ' ' + splittedName[index + 1]
        splittedName.splice(index + 1, 1)
      }
    }
  })
  return splittedName
}

export function removeCommonElement(units) {
  const commonElements = ['supermercado', 'supermercados', 'mercado', 'mercados']
  units.forEach((unitSplittedName) => {
    unitSplittedName.forEach((splittedName, index) => {
      if (commonElements.includes(splittedName.toLowerCase())) {
        unitSplittedName.splice(index, 1)
      }
    })
  })
  return units
}

export function filterUnit(units, filter) {
  return units.filter((item) => filter.includes(item.unit_name))
}
